import type { ComponentType } from "react";

import type { MobileNavProps } from "./subcomponents/MobileNav";

export type MobileNavComponent = ComponentType<MobileNavProps>;

/**
 * Loads the mobile menu sheet (base-ui Dialog) on demand, so its code is not
 * part of every page. Rejects when the chunk cannot be fetched, for example
 * offline; callers must handle that.
 */
export const loadMobileNav = (): Promise<MobileNavComponent> =>
  import("./subcomponents/MobileNav").then((module) => module.MobileNav);
